import React, { useEffect } from 'react';
import proptypes from 'prop-types';
import {
  arrayOf,
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { Link, Skeleton, SkeletonBlock, Typography } from '@one-thd/sui-atomic-components';

const { string } = proptypes;

const StateServicesComponent = ({ state }) => {
  useEffect(() => {
    if (window.LIFE_CYCLE_EVENT_BUS?.lifeCycle?.trigger) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('state-services.ready');
    }
  }, []);

  const { data, loading, error } = useDataModel('storeDirectoryByState', {
    variables: { state }
  });

  const servicesInfo = data?.storeDirectoryByState?.servicesInfo || [];
  const stateName = data?.storeDirectoryByState?.stateName || '';

  if (loading) {
    return (
      <article data-component="StateServicesPlaceholder">
        <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
          <SkeletonBlock aspect="wide" height="700px" />
        </Skeleton>
      </article>
    );
  }

  if (!servicesInfo?.length || error) return null;

  return (
    <article data-component="StateServices">
      <section>
        <Typography variant="h1" weight="display">
          {stateName} City Locations
        </Typography>
      </section>
      <section className="sui-columns-2 sui-p-4 md:sui-columns-3 lg:sui-columns-6 lg:sui-gap-10">
        {servicesInfo.map(({ city: cityName, localCityPageLink }, cityIndex) => (
          <div className="sui-mb-4" key={`${cityName}-${cityIndex}`}>
            <Link
              underline="none"
              id={`${cityName}-${cityIndex}`}
              href={localCityPageLink}
            >
              {`${cityName} Home Depot Locations`}
            </Link>
          </div>
        ))}
      </section>
    </article>
  );
};

const propTypes = {
  state: string.isRequired
};

StateServicesComponent.displayName = 'StateServices';

const dataModel = {
  storeDirectoryByState: params({ state: stringType().isRequired() }).shape({
    stateName: stringType(),
    servicesInfo: arrayOf(shape({
      city: stringType(),
      localCityPageLink: stringType(),
    }))
  })
};

StateServicesComponent.dataModel = dataModel;
StateServicesComponent.propTypes = propTypes;

const HydratedComponent = withHydrator({
  delay: 500,
  id: 'state-directory',
  placeholder: (
    <div data-component="StateServicesPlaceholder">
      <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
        <SkeletonBlock aspect="wide" height="750px" />
      </Skeleton>
    </div>
  ),
  scrollBuffer: 100,
}, StateServicesComponent);

const StateServices = withDynamicComponent(HydratedComponent);

StateServices.dataModel = dataModel;
StateServices.propTypes = propTypes;

export { StateServices };
